import { get, post } from "@services/apiService.js";

export default {
  // checkUrlDuplicate(data) {
  //   return post(`/v4/design-manager/v1/page/check-url`, data)
  //     .then((response) => {
  //       return response.data || {};
  //     })
  //     .catch((error) => {
  //       throw error;
  //     });
  // },
  getTemplateList(data) {
    return get(`/v4/template/v1/list`, data)
      .then((response) => {
        return response.data || {};
      })
      .catch((error) => {
        throw error;
      });
  },
  getTemplateCategories(data) {
    return get(`/v4/template/v1/categories`, data)
      .then((response) => {
        return response.data || {};
      })
      .catch((error) => {
        throw error;
      });
  },
  postTemplateSelect(data) {
    return post(`/v4/template/v1/select`, data)
      .then((response) => {
        return response.data || {};
      })
      .catch((error) => {
        throw error
      })
  }
};
